const locale = {
  noData: 'No Data'
};
export default locale;